import React, { useEffect, useState } from "react";
import {
  MDBContainer,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBCol,
  MDBRow,
  MDBCard,
  MDBCardHeader,
  MDBCardBody,
} from "mdbreact";
import "./Qualification.scss";
import QualificationDropdowns from "./QualificationDropdowns";
import { getDdSCACData } from "../CarrierMaster/CarrierMasterPage/CarrierMasterPageService";
import {
  getDdServiceTypeData,
  getDdOriginDestinationData,
  getCountryRegionData,
  getQualificationCarrierTableData,
  getServiceLevelData,
  authorization,
} from "./qualificationService";
import { getTransportationModeData } from "../CarrierMaster/CarrierContact/CarrierContactService";
import QualificationTable from "./QualificationTable";
import { getUserDetails } from "../NCRMAuthorization/Authorizationservice";
import { toast, ToastContainer } from "react-toastify";
import * as AuthServices from "../../src/NCRMAuthorization/Authorizationservice.js";
import BlockUi from '@availity/block-ui';
import {Circles} from "react-loader-spinner";

function Qualification() {
  const [ddData, setDdData] = useState({
    carrier: null,
    serviceType: null,
    mode: null,
    originGeo: null,
    destinationGeo: null,
    origin: null,
    destination: null,
    serviceLevel: null
  });
  const [userData, setUserData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [blocking, setBlocking] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [lastSearchState, setLastSearchState] = useState([]);

  useEffect(() => {
    let isCancelled = false;
    const getDdData = async () => {
      let response1 = await getDdSCACData();
      let response2 = await getDdServiceTypeData();
      let response3 = await getTransportationModeData();
      let response4 = await getDdOriginDestinationData();
      let response5 = await getUserDetails();
      let segmentResponse = await AuthServices.getSegments();
      let serviceLevelData = await getServiceLevelData();
      const [originDestType,originDestCountry,originDestPort] =  getOriginDestinationValues(response4);
      const gcpTrimData =  getOriginDestinationTrim(response4);

      console.log(segmentResponse)

      if (!isCancelled) {
        setDdData({
          ...ddData,
          carrier: response1,
          serviceType: response2,
          mode: response3,
          originGeo: Object.keys(response4[0]).map(
            (str) => str.charAt(0).toUpperCase() + str.slice(1)
          ),
          destinationGeo: Object.keys(response4[0]).map(
            (str) => str.charAt(0).toUpperCase() + str.slice(1)
          ),
          origin: [],
          destination: [],
          originDestination: response4,
          primaryOwner: segmentResponse,
          secondaryOwner: segmentResponse,
          serviceLevel: serviceLevelData,
          originDestgeoData: originDestType,
          originDestCountryData: originDestCountry, // origin country
          originDestPortData: originDestPort,  //origin destination port
          originDestinationTrimData: gcpTrimData
        });
        setUserData(response5["RESULT"]);
        setBlocking(false);
      }
    };

    getDdData();
    return () => {
      isCancelled = true;
    };
  }, []);

  let getOriginDestinationValues = (gcpData) => {
    let _geo = [];
    let _country = [];
    let _port = [];

    gcpData.map(gcp =>{
      if (!_geo.find((element) => element.text == gcp.geo)){
        _geo.push({text: gcp.geo, value: gcp.geo})
      }
      if (!_country.find((element) => element.text == gcp.country)){
        _country.push({text: gcp.country, value: gcp.country.split('-')[0]})
      }
      if (!_port.find((element) => element.text == gcp.port)){
        _port.push({text: gcp.port, value: gcp.port.split('-')[0].split('_')[1], displayText: gcp.port.split('_')[1]} )
      }
    })

    _geo = [...new Set(_geo)];
    _country = [...new Set(_country)];
    _port = [...new Set(_port)];

    return [_geo,_country,_port];
  }

  let getOriginDestinationTrim = (gcpData) => {
    let gcpTrim = [];
    gcpData.map(gcp => gcpTrim.push({port: gcp.port.split('-')[0].split('_')[1], geo: gcp.geo, country: gcp.country.split('-')[0]}) );
    return gcpTrim;
  }

  const onSearchClick = async (payloadData) => {
    setBlocking(true);
    setErrorMsg("");
    setLastSearchState(payloadData);
    let _tableData = await getQualificationCarrierTableData(payloadData);
    setBlocking(false);

    console.log("_tableData");
    console.log(_tableData);
    // _tableData = _tableData.map((res) => ({
    //   ...res,
    //   destinationValue: res["destinationValue"].split("_")[1],
    //   originValue: res["originValue"].split("_")[1],
    // }));
    setTableData(_tableData);
    if (!_tableData.length) {
      toast.warn("No records found");
      setErrorMsg("No records found");
    }
  };

  return (
    <>
      <div className="qualification-page" >
        <BlockUi   
          tag="div"
          blocking={blocking}
          loader={
            <Circles
            color="#00BFFF"
            height="100"
            width="100"
            timeout="6000" //3 secs
        />
          }
        >
          <ToastContainer position="top-right" autoClose={5000} />
          <MDBContainer fluid>
            <MDBRow>
              <MDBCol sm="12" className="titleBox">
                <label>Pre-Qualified Carriers</label>
              </MDBCol>
            </MDBRow>
          </MDBContainer>

          <MDBContainer fluid className="qualification-card">
            <MDBRow className="qualification-card-row">
              <MDBCard className="cc-card">
                <MDBCardHeader className="cc-card-header">
                  Pre Qualified Carrier
                </MDBCardHeader>
                <MDBCardBody>
                  {ddData["carrier"] &&
                    ddData["mode"] &&
                    ddData["serviceType"] && (
                      <QualificationDropdowns
                        ddData={ddData}
                        onSearchClick={onSearchClick}
                      />
                    )}
                </MDBCardBody>
              </MDBCard>
            </MDBRow>
          </MDBContainer>

          <MDBContainer fluid>
            <MDBRow style={{ paddingBottom: "50px", justifyContent: "center" }}>
              {tableData.length !== 0 && errorMsg === "" && (
                <QualificationTable
                  tableData={tableData}
                  ddData={ddData}
                  onSearchClick={onSearchClick}
                  userData={userData}
                  lastSearchState={lastSearchState}
                />
              )}

              {tableData.length === 0 && errorMsg !== "" && (
                <span style={{ fontSize: "22px", paddingTop: "23px",textAlign:"center" }}>
                  {errorMsg}
                </span>
              )}
            </MDBRow>
          </MDBContainer>
        </BlockUi> 
      </div>
    </>
  );
}

export default Qualification;
